import PrivacyPolicySection from "./PrivacyPolicySection";
export default PrivacyPolicySection;